// utils.js
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dismissNotification } from './actions';
import { NOTIFICATION_TIMEOUT_NONE } from './constants';
import makeSelectNotificationEngine from './selectors';

export default function useNotificationAutoDismiss() {
  const dispatch = useDispatch();
  const selectNotificationEngine = makeSelectNotificationEngine();
  const { active = [] } = useSelector(selectNotificationEngine);

  // Store timers by notification ID
  const timersRef = useRef(new Map());

  useEffect(() => {
    const timers = timersRef.current;

    // Create timers for new notifications
    active.forEach((notif) => {
      const { id, timeout } = notif;

      if (
        timeout !== NOTIFICATION_TIMEOUT_NONE &&
            !timers.has(id)
      ) {
        const t = setTimeout(() => {
          dispatch(dismissNotification(id));
          timers.delete(id);
        }, timeout);
        timers.set(id, t);
      }
    });

    // Clean up timers for notifications that are no longer active
    const activeIds = new Set(active.map((n) => n.id));
    Array.from(timers.entries()).forEach(([id, t]) => {
      if (!activeIds.has(id)) {
        clearTimeout(t);
        timers.delete(id);
      }
    });

    // Cleanup on component unmount
    return () => {
      Array.from(timers.values()).forEach((t) => clearTimeout(t));
      timers.clear();
    };
  }, [active, dispatch]);
}
